<template>
  <div class="app-header">
    <div class="app-container d-flex w-100">
      <div class="app-sidemenu d-flex align-items-center me-2">
        <slot name="previous"></slot>

        <a class="btn btn-md btn-icon btn-circle btn-icon-light-dark btn-active-light-dark" :title="$t('메뉴')" v-b-toggle.sidebar-menu>
          <i class="bi bi-list" style="font-size: 28px; font-weight: bolder;"></i>
        </a>

        <b-sidebar id="sidebar-menu" bg-variant="white" backdrop shadow>
          <!-- 메뉴 (사이드) -->
          <div class="app-header-menu app-header-menu-side d-flex">
            <div class="menu menu-column menu-rounded px-4">
              <div v-for="(depth1, title, idx1) in menus" :key="idx1" class="menu-item menu-accordion">
                <span v-if="depth1.path" class="menu-link" @click.stop="$go(depth1.path)" :class="{ active: depth1.path == $route.path }">
                  <span class="menu-title fs-6">{{title}}</span>
                </span>
                <template v-else>
                  <span class="menu-link" @click.stop="$go(Object.values(depth1)[0].path)" :class="{ active: title == $route.meta.group }">
                    <span class="menu-title fs-6">{{title}}</span>
                  </span>
                  <div v-for="({ path }, title, idx2) in depth1" :key="idx2" class="ps-1">
                    <div class="menu-item">
                      <span class="menu-link" @click.stop="$go(path)" :class="{ active: path == $route.path }">
                        <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
                        <span class="menu-title fs-6">{{ title }}</span>
                      </span>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </b-sidebar>
      </div>

      <div class="d-flex flex-grow-1 justify-content-center">
        <!-- 로고 -->
        <div class="d-flex align-items-center me-4" v-if="$store.state.settings.appLayout.indexOf('-header') > 0">
          <a class="app-logo" @click="device == 'WEB' ? $go('/') : null">
            <img alt="Logo" :src="`/img/Mizuho_logo.svg.png`" class="h-30px app-sidebar-logo-default" />
          </a>
        </div>

        <!-- 메뉴 -->
        <div class="app-header-menu app-header-menu-main d-flex flex-grow-1">
          <div class="menu menu-row menu-rounded px-4">
            <div v-for="(depth1, title, idx1) in menus" :key="idx1" class="menu-item menu-accordion mx-1">
              <span v-if="depth1.path" class="menu-link" href="#" @click="$go(depth1.path)" :class="{ active: depth1.path == $route.path }">
                <span class="menu-title fs-6">{{title}}</span>
              </span>
              <div v-else @mouseover="onMenuOver(`header-menu-${idx1}`)" @mouseleave="onMenuLeave">
                <b-dropdown :id="`header-menu-${idx1}`" size="sm" variant="link" class="d-block" toggle-class="w-100 p-0" no-caret>
                  <template #button-content>
                    <span class="menu-link" href="#" @click="$go(Object.values(depth1)[0].path)" :class="{ active: title == $route.meta.group }">
                      <span class="menu-title fs-6">{{title}}</span>
                    </span>
                  </template>
                  <b-dropdown-item v-for="({ path }, title, idx2) in depth1" :key="idx2" @click="$go(path)" :active="path == $route.path">
                    {{ title }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 프로필 -->
      <div class="app-header-profile d-flex flex-grow-0 align-items-center">
        <slot name="left"></slot>
        <slot name="right"></slot>
        <Profile></Profile>
      </div>
    </div>
  </div>
</template>

<script>
import routes from '../../routes';
import Profile from "@/components/layout/Profile.vue";

export default {
  components: { Profile },
  data: () => ({
    menus: {},
    devMode: location.hostname == 'localhost',
  }),
  computed: {
    user() { return this.$store.state.user },
    darkmode() { return this.$store.state.settings.darkmode },
    sidebar() { return this.$store.state.settings.sidebar },
    device() { return this.$getDevice(); },
  },
  watch: {
    'user.userLang': 'setMenus',
    'user.kind': {
      async handler(v, old) {
        if (old) {
          let { accessToken, refreshToken, custId } = this.user;
          if (v != 'main') custId = '';
          const { data: { accessToken: a, refreshToken: r, user: u } } = await this.$api(v == 'main' ? 'main/enterMain' : 'adm/enterAdm', { accessToken, refreshToken, custId });
          await this.$store.commit('user', { accessToken: a, refreshToken: r, auths: u.auths, grpId: u.grpId });
        }
        await this.setMenus();
        if (this.$route.path == '/redirect') this.$router.replace(Object.values(this.menus)[0].path);
      },
      immediate: true,
    },
  },
  methods: {
    onMenuOver(menuId) {
      document.getElementById(menuId).querySelector('.dropdown-menu').classList.add('show');
    },
    onMenuLeave() {
      document.querySelectorAll('.app-header-menu .dropdown-menu').forEach(menu => {
        menu.classList.remove('show');
      });
    },
    async setMenus() {
      if(!this.user.linkKey) {
        const view = this.user.kind;
        this.menus = {};
        const menus = (await this.$api(`${view}/selectMenuList`, { custId: this.user.custId })).list;
        menus.forEach(m => {
          const tMenu = routes.find(r => r.path == m.url);
          if(tMenu) {
            if(m.pMenuId == 0) {
              this.menus[m.menuNm] = menus.filter(m2 => m2.pMenuId == m.menuId).length == 0 ? tMenu : {};
            } else {
              const parentNm = menus.find(m2 => m2.menuId == m.pMenuId).menuNm;
              this.menus[parentNm][m.menuNm] = tMenu;
            }
          }
        });
        this.$forceUpdate();
      }
    },
  }
}
</script>

<style>
.app-header-menu .dropdown-item {
  padding: 8px 12px;
}
</style>